import { StorageService } from './../services/storage/storage.service';
import { take } from 'rxjs/operators';
import { LoginService } from './../login/login.service';
import { LoginStorage } from './../login/login.storage';
import { Router, } from '@angular/router';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../login/login.storage";
import * as i2 from "../services/storage/storage.service";
import * as i3 from "@angular/router";
import * as i4 from "../login/login.service";
export class ViabilidadeGuard {
    constructor(loginStorage, storageService, router, loginService) {
        this.loginStorage = loginStorage;
        this.storageService = storageService;
        this.router = router;
        this.loginService = loginService;
    }
    canActivateChild(next, state) {
        if (this.loginStorage.isContainsToken()) {
            return true;
        }
        if (next.queryParams.login && next.queryParams.token) {
            const { login, token } = next.queryParams;
            const subject = new Subject();
            this.storageService.renewUser(JSON.stringify({ login, token }))
                .pipe(take(1))
                .subscribe((result) => {
                this.loginStorage.register(result.usuario);
                this.loginStorage.registerDataExpiracao(result.dataExpiracao);
                if (result.usuario.hasOwnProperty('lojaTO')) {
                    this.loginStorage.registerAgente(result.usuario.lojaTO.agenteTO);
                }
                subject.next(true);
                subject.complete();
            }, (err) => {
                subject.next(false);
                subject.complete();
                this.goToLogin();
            });
            return subject;
        }
    }
    goToLogin() {
        this.router.navigate(['/login']);
    }
}
ViabilidadeGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ViabilidadeGuard_Factory() { return new ViabilidadeGuard(i0.ɵɵinject(i1.LoginStorage), i0.ɵɵinject(i2.StorageService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.LoginService)); }, token: ViabilidadeGuard, providedIn: "root" });
